import * as React from 'react'
import { ReactElement } from 'react'
import { DataPromise } from '../../context/AxiosContext'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'

export type EntityComboboxProps<E> = Omit<BaseComboboxProps<E>, 'entities'> & {
    dataPromise: DataPromise<E[]>
}

export default function EntityCombobox<E>(props: EntityComboboxProps<E>): ReactElement {
    return <BaseCombobox<E> entities={props.dataPromise?.data || []} {...props} />
}
